import { render, staticRenderFns } from "./ResultTextModal.vue?vue&type=template&id=6f5a9fc0"
import script from "./ResultTextModal.vue?vue&type=script&lang=js"
export * from "./ResultTextModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports